import { render } from "./DbDeleteEditorCmp.vue?vue&type=template&id=9f190394"
import script from "./DbDeleteEditorCmp.vue?vue&type=script&lang=js"
export * from "./DbDeleteEditorCmp.vue?vue&type=script&lang=js"

import "./DbDeleteEditorCmp.vue?vue&type=style&index=0&id=9f190394&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__